import { userRoles } from '../shared/enums/dropdownEnums';
import useRoles from './useRoles';

const useHasRole = (role: userRoles) => {
    const roles = useRoles();
    return roles.includes(role);
};

export default useHasRole;
